define('constants/contactAddressLabelEnumerations',[], function () {
    return  {
        Work: 1,
        Personal: 2,
        Other: 3,
    };
});

